export default "__VITE_ASSET__DUkW7nJP__"